// ABOUTME: Shop/store icon for sidebar navigation
// ABOUTME: Used to navigate to the lactate analyzer shop page

import type { FC } from "react"

interface ShopSidebarIconProps {
  className?: string
  size?: number
  color?: string
}

export const ShopSidebarIcon: FC<ShopSidebarIconProps> = ({ className, size = 16, color = "currentColor" }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9h18v10a2 2 0 01-2 2H5a2 2 0 01-2-2V9zM3 9l1.5-5h15L21 9M12 4v5M7.5 4l-1 5M16.5 4l1 5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
